import { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import GruposClientesService from './Service';

interface GruposClientesContextProps {
    data: any[];
    loading: boolean;
    error: boolean;
    reloadData: () => Promise<void>;
}

const GruposClientesContext = createContext<GruposClientesContextProps | undefined>(undefined);

export const useGruposClientesContext = () => {
    const context = useContext(GruposClientesContext);
    if (!context) {
        throw new Error('useGruposClientesContext must be used within a UsersProvider');
    }
    return context;
};

export const GruposClientesProvider = ({ children }: { children: ReactNode }) => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const reloadData = async () => {
        try {
            setError(false);
            const result = await GruposClientesService.findAll().then((result) => {
                return result?.data || [];
            });

            setData(result);
        } catch (error) {
            console.error('Error fetching GruposClientes:', error);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        reloadData();
    }, []);

    return <GruposClientesContext.Provider value={{ data, reloadData, loading, error }}>{children}</GruposClientesContext.Provider>;
};
